import { css } from "styled-components"

export const resetButtonStyles = css`
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`
